















































































































































































































// echart相关
import * as echarts from "echarts/core";
import {
  TooltipComponent,
  TooltipComponentOption,
  LegendComponent,
  LegendComponentOption,
  TitleComponent,
  TitleComponentOption,
} from "echarts/components";
import { PieChart, PieSeriesOption } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);
type EChartsOption = echarts.ComposeOption<
  | TitleComponentOption
  | TooltipComponentOption
  | LegendComponentOption
  | PieSeriesOption
>;
// 接口和其他
import {
  getCourseIncomeDetailApi,
  getCourseIncomeListApi,
  getCourseIncomeData,
} from "@/api/statistics";
import json2csv from "json2csv";
import { Vue, Component } from "vue-property-decorator";
import { dateFormat } from "@/utils/timeFormat";
import { createOperationLogApi } from "@/api/store";
import { roundNumbers } from "@/utils/roundNumbers";
import { getSeleSubjectsList } from "@/api/globalSearch";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  components: {
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  searchInfo: any = {
    date: [],
    course_type: -1,
  };
  subjectList: any = [];
  courseDataStatistics: any[] = []; // 课程收入统计
  myChart: any = {};
  exporting: boolean = false;
  allTableData: any[] = [];
  currentSortOption: any = {
    order: "descending",
    prop: "receivable_amount",
  };
  resizeMark = false;
  course_All: number = 0;
  mounted() {
    this.handleSubjectList("");
    const chartDom = document.getElementById("echart")!;
    this.myChart = echarts.init(chartDom);
    this.searchInfo.date = [
      dateFormat("YYYY-mm-dd", new Date().getTime() - 30 * 24 * 60 * 60 * 1000),
      dateFormat("YYYY-mm-dd", new Date().getTime()),
    ];
    this.getChartData();
    window.addEventListener("resize", () => {
      if (this.resizeMark) {
        return false;
      }
      this.resizeMark = true;
      setTimeout(() => {
        this.myChart.resize();
        this.resizeMark = false;
      }, 1000);
    });
  }
  handleSubjectList(v: any) {
    getSeleSubjectsList({
      page: 1,
      page_size: 100,
      title: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.subjectList = res.data.list;
      }
    });
  }
  handleDataListSort(arr: any[]) {
    let list: any[] = [];
    arr.map((item: any) => {
      list.push({
        course_id: item.course.course_id,
        course_name: item.course.title,
        subject_name: item.subject ? item.subject.subject_title : "-",
        course_type: item.course.course_type === 1 ? "1vN" : "1v1",
        buy_num: item.buy_num,
        receivable_amount: item.receivable_amount,
        transfer_join_num: item.transfer_join_num,
        transfer_join_amount: item.transfer_join_amount,
        transfer_out_num: item.transfer_out_num,
        transfer_out_amount: item.transfer_out_amount,
        refund_num: item.refund_num,
        refund_amount: item.refund_amount,
      });
    });
    list = this.sortList(list);
    return list;
  }
  getChartData() {
    this.getList();
    this.getDetailList();
  }
  handleSearch() {
    this.getDetailList();
  }
  // 汇总和echarts
  getList() {
    if (this.searchInfo.date.length === 2) {
      const option: getCourseIncomeData = {
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      };
      getCourseIncomeListApi(option).then((res: any) => {
        const list = this.handleDataListSort(res.data.list);
        this.courseDataStatistics = [];
        const titleList: any[] = [];
        const quantitySource: any[] = [];
        const incomeSource: any[] = [];
        let buy_num: number = 0;
        let receivable_amount: number = 0;
        let transfer_join_num: number = 0;
        let transfer_join_amount: number = 0;
        let transfer_out_num: number = 0;
        let transfer_out_amount: number = 0;
        let refund_num: number = 0;
        let refund_amount: number = 0;
        list.map((item: any) => {
          buy_num = buy_num + Number(item.buy_num);
          receivable_amount =
            receivable_amount + Number(item.receivable_amount);
          transfer_join_num =
            transfer_join_num + Number(item.transfer_join_num);
          transfer_join_amount =
            transfer_join_amount + Number(item.transfer_join_amount);
          transfer_out_num = transfer_out_num + Number(item.transfer_out_num);
          transfer_out_amount =
            transfer_out_amount + Number(item.transfer_out_amount);
          refund_num = refund_num + Number(item.refund_num);
          refund_amount = refund_amount + Number(item.refund_amount);
          if (titleList.indexOf(item.course_name) < 0) {
            titleList.push(item.course_name);
          }
          quantitySource.push({
            value: item.buy_num,
            name: item.course_name,
          });
          incomeSource.push({
            value: roundNumbers(item.receivable_amount),
            name: item.course_name,
          });
          item.receivable_amount = roundNumbers(item.receivable_amount);
        });
        const incomeTotal = Number(
          (
            receivable_amount -
            transfer_out_amount +
            (transfer_join_amount - refund_amount)
          ).toFixed(2)
        );
        const quantityTotal =
          buy_num + transfer_out_num + transfer_join_num + refund_num;
        // 课程收入统计
        const revenueAmountList: any = {
          arr: [
            {
              name: "课程收入合计",
              num:
                incomeTotal >= 0
                  ? ` ${roundNumbers(incomeTotal.toFixed(2))}`
                  : `- ${roundNumbers(incomeTotal.toFixed(2))}`,
            },
            {
              name: "购买课程收入金额",
              num:
                receivable_amount >= 0
                  ? ` ${roundNumbers(receivable_amount.toFixed(2))}`
                  : `- ${roundNumbers(receivable_amount.toFixed(2))}`,
            },
            {
              name: "转出课程支出金额",
              num: `- ${roundNumbers(transfer_out_amount.toFixed(2))}`,
            },
            {
              name: "转入课程收入金额",
              num:
                transfer_join_amount >= 0
                  ? ` ${roundNumbers(transfer_join_amount.toFixed(2))}`
                  : `- ${roundNumbers(transfer_join_amount.toFixed(2))}`,
            },
            {
              name: "退款课程支出金额",
              num: `- ${roundNumbers(refund_amount.toFixed(2))}`,
            },
          ],
        };
        const otherAmountList: any = {
          arr: [
            {
              name: "转入转出/退款/购课人次合计",
              num: quantityTotal,
            },
            {
              name: "购买课程人次",
              num: buy_num,
            },
            {
              name: "转出课程人次",
              num: transfer_out_num,
            },
            {
              name: "转入课程人次",
              num: transfer_join_num,
            },
            {
              name: "退款课程人次",
              num: refund_num,
            },
          ],
        };
        this.courseDataStatistics.push(revenueAmountList, otherAmountList);
        // echarts
        const option: EChartsOption = {
          title: [
            {
              subtext: "课程购买人次",
              textAlign: "center",
              left: "25%",
              top: "85%",
              subtextStyle: {
                fontSize: 14,
              },
            },
            {
              subtext: "课程实收金额",
              textAlign: "center",
              left: "60%",
              top: "85%",
              subtextStyle: {
                fontSize: 14,
              },
            },
          ],
          // color: ["#38DABB", "#FFB940", "#409EFF"],
          tooltip: {
            trigger: "item",
            formatter: "{b} <br/>{a} : {c} [{d}%]",
            backgroundColor: "rgba(51,51,51,0.9)",
            borderColor: "rgba(0,0,0,0)",
            padding: [16, 24],
            textStyle: { color: "#fff" },
          },
          legend: {
            type: "scroll",
            orient: "vertical",
            right: 10,
            top: 20,
            data: titleList,
            formatter: (name: string): string => {
              if (name.length > 15) {
                return name.slice(0, 14) + "...";
              }
              return name;
            },
            itemWidth: 6,
            itemHeight: 6,
            icon: "circle",
            pageIconSize: 10,
            textStyle: {
              fontSize: 12,
              lineHeight: 15,
            },
          },
          series: [
            {
              name: "购课人次",
              type: "pie",
              radius: ["40%", "70%"],
              center: ["25%", "50%"],
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                },
              },
              data: quantitySource,
            },
            {
              name: "课程实收",
              type: "pie",
              radius: ["40%", "70%"],
              center: ["60%", "50%"],
              label: {
                show: false,
              },
              emphasis: {
                label: {
                  show: false,
                },
              },
              data: incomeSource,
            },
          ],
        };
        option &&
          this.myChart.setOption(option, {
            notMerge: true,
          });
      });
    }
  }
  // 明细
  getDetailList() {
    if (this.searchInfo.date.length === 2) {
      const option: getCourseIncomeData = {
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      };
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.course_type > -1) {
        option.course_type = this.searchInfo.course_type;
      }
      getCourseIncomeDetailApi(option).then((res: any) => {
        this.course_All = 0;
        const list = this.handleDataListSort(res.data.list);
        list.map((item: any) => {
          // 每一条数据相加
          item.otherTotal =
            item.buy_num +
            item.transfer_join_num +
            item.transfer_out_num +
            item.refund_num;
          item.c_Total = (
            Number(item.receivable_amount) -
            Number(item.transfer_out_amount) +
            (Number(item.transfer_join_amount) - Number(item.refund_amount))
          ).toFixed(2);
          // 去0
          item.receivable_amount =
            Number(item.receivable_amount) >= 0
              ? roundNumbers(item.receivable_amount)
              : `-${roundNumbers(item.receivable_amount)}`;
          item.transfer_out_amount = `-${roundNumbers(
            item.transfer_out_amount
          )}`;
          item.transfer_join_amount =
            Number(item.transfer_join_amount) >= 0
              ? roundNumbers(item.transfer_join_amount)
              : `-${roundNumbers(item.transfer_join_amount)}`;
          item.refund_amount = `-${roundNumbers(item.refund_amount)}`;
          item.courseTotal =
            Number(item.c_Total) >= 0
              ? roundNumbers(item.c_Total)
              : `-${roundNumbers(item.c_Total)}`;
          this.course_All = this.course_All + Number(item.courseTotal);
        });
        this.allTableData = list;
      });
    }
  }
  sortList(list: any[]) {
    const copy = [...list];
    copy.sort((a: any, b: any) => {
      return (
        Number(b[this.currentSortOption.prop]) -
        Number(a[this.currentSortOption.prop])
      );
    });
    copy.map((item: any, index: number) => {
      item.index = index + 1;
    });
    if (this.currentSortOption.order === "ascending") {
      copy.reverse();
    }
    return copy;
  }
  handleSortChange(data: any) {
    this.currentSortOption = {
      order: data.order,
      prop: data.prop,
    };
    this.allTableData = this.sortList(this.allTableData);
    let n = 0;
    this.allTableData.map((it: any, ind: any) => {
      n += 1;
      it.index = n;
    });
  }
  // 导出
  handleExport() {
    if (this.exporting) {
      return false;
    }
    this.exporting = true;
    try {
      const result = json2csv.parse(
        [
          {
            index: "排名",
            course_name: "课程名称",
            subject_name: "科目",
            course_type: "课程类型",
            otherTotal: "转入转出/退款/购课人次合计",
            courseTotal: "课程收入合计",
            buy_num: "购买课程人次",
            receivable_amount: "购买课程收入金额",
            transfer_out_num: "转出课程人次",
            transfer_out_amount: "转出课程支出金额",
            transfer_join_num: "转入课程人次",
            transfer_join_amount: "转入课程收入金额",
            refund_num: "退款课程人次",
            refund_amount: "退款课程支出金额",
          },
          ...this.allTableData,
        ],
        {
          fields: [
            "index",
            "course_name",
            "subject_name",
            "course_type",
            "otherTotal",
            "courseTotal",
            "buy_num",
            "receivable_amount",
            "transfer_out_num",
            "transfer_out_amount",
            "transfer_join_num",
            "transfer_join_amount",
            "refund_num",
            "refund_amount",
          ],
          header: false,
        }
      );
      //非IE浏览器
      const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
      //使用a标签的download属性实现下载功能
      const link = document.createElement("a");
      link.href = encodeURI(csvContent);
      link.download =
        "课程收入数据[" +
        this.searchInfo.date[0] +
        " ~ " +
        this.searchInfo.date[1] +
        "].csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // 3秒导出间隔
      setTimeout(() => {
        this.exporting = false;
      }, 3000);
      createOperationLogApi({
        code: 10504,
        detail: "导出课程收入数据明细",
      }).then(() => {
        this.$message({
          type: "success",
          message: "导出成功",
        });
      });
    } catch (err: any) {
      this.$message({
        type: "error",
        message: err.toString(),
      });
    }
  }
  // 跳转订单明细
  toOrderLine(id: number) {
    const url = `${window.location.origin}/#/layout/finance/order?tab=orderline&cid=${id}&order_type=1&start=${this.searchInfo.date[0]}&end=${this.searchInfo.date[1]}`;
    window.open(encodeURI(url), "_blank");
  }
}
